import ProjectScope from "../components/ProjectScope";
import WebApp from "../components/WebApp";

const ProjectScopePage = () => {
  return (
    <WebApp>
      <ProjectScope></ProjectScope>
    </WebApp>
  );
};


export default ProjectScopePage;